import { UsersFormDataTenantUserInvite } from './UsersFormDataTenantUserInvite';

export class UsersFormData {
  tenantUserInvite: UsersFormDataTenantUserInvite = new UsersFormDataTenantUserInvite();
}
